<template>
  <div id="new-zgb-team-members-edit" class="edit-wrap">
    <v-dialog v-model="DialogFlag" max-width="1200px">
      <!-- upload dialogs (behavior unchanged) -->
      <v-dialog v-model="memberDocumentPrompt" persistent scrollable>
        <upload-selected-member-document
          :record="member"
          v-if="memberDocumentPrompt"
          :showDialog="memberDocumentPrompt"
          @hideDialog="hideMemberDocumentPrompt($event)"
        />
      </v-dialog>

      <v-dialog v-model="memberPhotoPrompt" persistent scrollable>
        <upload-selected-member-photo
          :record="member"
          v-if="memberPhotoPrompt"
          :showDialog="memberPhotoPrompt"
          @hideDialog="hideMemberPhotoPrompt($event)"
        />
      </v-dialog>

      <v-card class="form-card elevation-6 rounded-lg">
        <!-- Professional Gradient Header -->
        <v-sheet class="edit-header" tile>
          <div class="header-content">
            <!-- Left Section: Icon + Title -->
            <div class="header-title-section">
              <div class="title-icon-wrapper">
                <v-icon large color="white" class="title-icon"
                  >mdi-account-edit</v-icon
                >
              </div>
              <div class="title-content">
                <h2 class="page-title">{{ pageDescription }}</h2>
                <p class="page-desc">
                  <v-icon x-small class="mr-1">mdi-calendar-check</v-icon>
                  Edit member profile for {{ NextYearName }}
                </p>
              </div>
            </div>

            <!-- Right Section: Actions -->
            <div class="header-actions-top">
              <v-chip
                small
                color="rgba(255, 255, 255, 0.25)"
                text-color="white"
                class="year-badge"
              >
                <v-icon left x-small>mdi-calendar-check</v-icon>
                {{ NextYearName }}
              </v-chip>

              <v-btn
                icon
                small
                color="white"
                class="icon-action-btn"
                @click.prevent="refreshPageData"
                :loading="LoadingFlag"
                v-tooltip="'Refresh Data'"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-btn
                icon
                small
                color="white"
                class="icon-action-btn"
                @click="closePrompt"
                v-tooltip="'Close Dialog'"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-sheet>
        <v-form ref="form1" v-model="valid1" lazy-validation>
          <v-card-text>
            <small class="muted">* indicates required field</small>

            <v-container fluid>
              <v-row dense>
                <v-col cols="12" md="5">
                  <label class="field-label">
                    <v-icon x-small class="mr-1">mdi-briefcase</v-icon>
                    *Designation
                  </label>
                  <h4 class="readonly-text">{{ DesignationName }}</h4>
                </v-col>
                <v-col cols="12" md="4">
                  <label class="field-label"
                    ><v-icon x-small class="mr-1 text-error"
                      >mdi-asterisk</v-icon
                    >
                    <v-icon x-small class="mr-1"
                      >mdi-card-account-details</v-icon
                    >
                    Membership ID</label
                  >
                  <v-text-field
                    v-model="MembershipId"
                    dense
                    outlined
                    clearable
                    class="control-input"
                  />
                </v-col>

                <v-col cols="12" class="d-flex align-center">
                  <v-btn
                    @click.prevent="getMemberRecords"
                    :loading="SearchFlag"
                    color="primary"
                    elevation="4"
                    rounded
                    class="mr-3"
                  >
                    <v-icon left>mdi-account-search</v-icon>
                    Lookup Member
                  </v-btn>
                </v-col>
              </v-row>
              <br />
              <v-card
                class="member-details-card mb-5 rounded-lg elevation-3"
                v-if="MemberFlag"
              >
                <v-card-title class="details-card-header white--text py-3 px-4">
                  <v-icon color="white" class="mr-2"
                    >mdi-account-details</v-icon
                  >
                  <span>Member Details & Status</span>
                </v-card-title>
                <v-card-subtitle class="pb-0 pt-2 px-4 details-subtitle"
                  ><v-icon x-small class="mr-1">mdi-information-outline</v-icon
                  >Member profile information and verification
                  status</v-card-subtitle
                >
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-label">
                        <v-icon x-small class="mr-1 text-error"
                          >mdi-asterisk</v-icon
                        >
                        <v-icon x-small class="mr-1">mdi-calendar-today</v-icon>
                        Date of Birth
                      </div>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        :disabled="!!member.MemberDOB"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            v-model="member.MemberDOB"
                            label="Date of Birth"
                            persistent-hint
                            readonly
                            v-on="!member.MemberDOB ? on : {}"
                            background-color="#F3F6F9"
                            class="date-input"
                            validate-on-blur
                            solo
                            dense
                            :disabled="!!member.MemberDOB"
                            prepend-inner-icon="mdi-calendar"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="member.MemberDOB"
                          @input="menu1 = false"
                          :disabled="!!member.MemberDOB"
                          class="elevation-5"
                        ></v-date-picker>
                      </v-menu>
                      <div class="mt-1">
                        <v-chip
                          x-small
                          :color="
                            member.AadhaarVerifiedFlag ? 'success' : 'warning'
                          "
                          text-color="white"
                          class="verification-chip"
                        >
                          <v-icon left x-small>{{
                            member.AadhaarVerifiedFlag
                              ? "mdi-check-circle"
                              : "mdi-alert-circle"
                          }}</v-icon>
                          {{
                            member.AadhaarVerifiedFlag
                              ? "DOB verified by Aadhaar"
                              : "DOB not verified by Aadhaar"
                          }}
                        </v-chip>
                      </div>
                    </v-col>

                    <!-- Status chips with improved visual design -->
                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">
                        <v-icon x-small class="mr-1">mdi-account-box</v-icon>
                        Profile Verification
                      </div>
                      <v-chip
                        :color="member.ProfileUpdatedColor"
                        label
                        class="status-chip text-white"
                      >
                        <v-icon left small color="white">
                          {{
                            member.ProfileStatusFlag
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}
                        </v-icon>
                        {{ member.ProfileUpdatedTxt }}
                      </v-chip>
                      <br />
                      <div
                        v-if="member.MissingSteps"
                        class="pa-3 rounded-lg text-center"
                        style="
                          background-color: #fff3cd;
                          color: #856404;
                          border: 1px solid #ffeeba;
                        "
                      >
                        <strong>⚠️ Missing Steps:</strong>
                        {{ member.MissingSteps }}
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">
                        <v-icon x-small class="mr-1 text-error"
                          >mdi-asterisk</v-icon
                        >
                        <v-icon x-small class="mr-1">mdi-camera</v-icon>
                        Photo Update
                      </div>
                      <div class="d-flex align-center">
                        <v-chip
                          :color="
                            member.MemberImageFlag ? 'success' : 'warning'
                          "
                          label
                          class="status-chip mr-2"
                        >
                          <v-icon left small>{{
                            member.MemberImageFlag
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}</v-icon>
                          {{ member.MemberImageFlag ? "Completed" : "Pending" }}
                        </v-chip>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">
                        <v-icon x-small class="mr-1 text-error"
                          >mdi-asterisk</v-icon
                        >
                        <v-icon x-small class="mr-1">mdi-file-document</v-icon>
                        Age Proof Document
                      </div>
                      <div class="d-flex align-center">
                        <v-chip
                          :color="member.DocumentFlag ? 'success' : 'warning'"
                          label
                          class="status-chip mr-2"
                        >
                          <v-icon left small>{{
                            member.DocumentFlag
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}</v-icon>
                          {{ member.DocumentFlag ? "Completed" : "Pending" }}
                        </v-chip>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">
                        <v-icon x-small class="mr-1 text-error"
                          >mdi-asterisk</v-icon
                        >
                        <v-icon x-small class="mr-1"
                          >mdi-card-account-details</v-icon
                        >
                        Aadhaar Status
                      </div>
                      <v-chip
                        :color="member.AadhaarTextColor"
                        label
                        class="status-chip text-white"
                      >
                        <v-icon left small>{{
                          member.AadhaarVerifiedFlag
                            ? "mdi-check-circle"
                            : "mdi-alert-circle"
                        }}</v-icon>
                        {{ member.AadhaarVerifiedTxt }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-row class="mb-5" v-if="MemberFlag">
                <!-- Left: Portal Details -->
                <v-col cols="12" md="6">
                  <v-card
                    class="portal-details-card h-100 elevation-3 rounded-lg"
                  >
                    <v-card-title
                      class="portal-header white--text py-3 px-4 rounded-t-lg"
                    >
                      <v-icon left color="white" size="24">mdi-web</v-icon>
                      Portal Details
                    </v-card-title>
                    <v-card-text class="pa-4">
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <div class="portal-label">Membership ID</div>
                          <div class="portal-value">
                            {{ MembershipId || member.MembershipId || "NA" }}
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <div class="portal-label">Name</div>
                          <div class="portal-value">
                            {{ member.MemberName || MemberName || "NA" }}
                          </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <div class="portal-label">Designation</div>
                          <div class="portal-value">
                            {{ member.Designation || "NA" }}
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <div class="portal-label">Contact</div>
                          <div class="portal-value">
                            {{ member.MobileNo || member.MobileNo || "" }}
                          </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <div class="portal-label">Email</div>
                          <div class="portal-value">
                            {{ member.EmailId || "NA" }}
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <div class="portal-label">DOB</div>
                          <div class="portal-value">
                            {{ member.MemberDOB || "NA" }}
                          </div>
                        </v-col>

                        <v-col cols="12">
                          <div class="portal-label">Address</div>
                          <div class="portal-value">
                            {{ member.AddressTxt || "NA" }}
                          </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <div class="portal-label">Profile Update</div>
                          <div class="portal-value">
                            <v-chip
                              small
                              :color="member.ProfileUpdatedColor"
                              dark
                              >{{ member.ProfileUpdatedTxt }}</v-chip
                            >
                          </div>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <div class="portal-label">Aadhaar Verification</div>
                          <div class="portal-value">
                            <v-chip
                              small
                              :color="member.AadhaarTextColor"
                              dark
                              >{{ member.AadhaarVerifiedTxt }}</v-chip
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Right: Aadhaar Card -->
                <v-col cols="12" md="6">
                  <v-card
                    class="aadhaar-card-container elevation-3 h-100 rounded-lg"
                    outlined
                  >
                    <v-card-title
                      class="aadhaar-header white--text py-3 px-4 rounded-t-lg"
                    >
                      <v-icon left color="white" size="24"
                        >mdi-account-badge</v-icon
                      >
                      Verified Aadhaar Details
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <template v-if="member && member.AadhaarVerifiedFlag">
                        <v-card
                          elevation="0"
                          class="aadhaar-real-card mx-auto"
                          rounded="lg"
                          max-width="100%"
                        >
                          <div class="aadhaar-outer-wrapper">
                            <v-card-text class="pa-4">
                              <div class="d-flex aadhaar-content">
                                <div class="aadhaar-photo-section mr-4">
                                  <v-avatar
                                    size="90"
                                    class="aadhaar-photo-container mb-3"
                                  >
                                    <img
                                      v-if="member.PhotoUrl"
                                      :src="member.PhotoUrl"
                                      alt="Aadhaar Photo"
                                      class="aadhaar-photo"
                                    />
                                    <v-icon v-else size="50" color="#555555"
                                      >mdi-account</v-icon
                                    >
                                  </v-avatar>
                                </div>
                                <div
                                  class="aadhaar-details-section flex-grow-1"
                                >
                                  <div class="person-name-bilingual">
                                    <div class="name-hindi mb-1">
                                      {{ member.AadhaarName || "NA" }}
                                    </div>
                                    <div class="name-english">
                                      {{ member.AadhaarName || "NA" }}
                                    </div>
                                  </div>
                                  <div class="detail-row mt-2">
                                    <span class="detail-label"
                                      ><b>Date of Birth:</b></span
                                    >
                                    <span class="detail-value">{{
                                      member.AadhaarDob || "NA"
                                    }}</span>
                                  </div>
                                  <div class="detail-row">
                                    <span class="detail-label"
                                      ><b>Gender:</b></span
                                    >
                                    <span class="detail-value">{{
                                      member.AadhaarGender || "NA"
                                    }}</span>
                                  </div>
                                  <div>
                                    <span class="detail-label"
                                      ><b>Address:</b></span
                                    >
                                    <span class="detail-value address-text">{{
                                      member.AadhaarAddress || "NA"
                                    }}</span>
                                  </div>
                                  <div class="aadhaar-number-container mt-2">
                                    <div class="aadhaar-number-label">
                                      आधार / Aadhaar
                                    </div>
                                    <div class="aadhaar-number">
                                      <template v-if="member.AadhaarNumber">
                                        <span class="aadhaar-digit-group">{{
                                          member.AadhaarNumber
                                        }}</span>
                                      </template>
                                      <template v-else>XXXX XXXX XXXX</template>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="aadhaar-separator-line mt-3"></div>
                              <div
                                class="aadhaar-footer d-flex justify-space-between align-center mt-1"
                              >
                                <div class="aadhaar-issue-info caption">
                                  <div class="issue-date">
                                    Issued:
                                    {{
                                      member.AadhaarIssueDate || "01/01/2023"
                                    }}
                                  </div>
                                </div>
                                <div class="aadhaar-tagline">
                                  <span class="tagline-text-hindi"
                                    >आधार - आम आदमी का अधिकार</span
                                  >
                                </div>
                                <div class="verification-badge">
                                  <v-chip
                                    color="success"
                                    x-small
                                    dark
                                    class="verification-chip"
                                    ><v-icon left x-small
                                      >mdi-check-circle</v-icon
                                    >Verified</v-chip
                                  >
                                </div>
                              </div>
                            </v-card-text>
                          </div>
                        </v-card>
                      </template>
                      <template v-else>
                        <v-card-text class="pa-6 aadhaar-empty">
                          <div class="empty-inner">
                            <div class="empty-icon">
                              <v-icon large color="error"
                                >mdi-alert-circle-outline</v-icon
                              >
                            </div>
                            <div class="empty-title">
                              Aadhaar details not found
                            </div>
                            <div class="empty-subtitle caption">
                              No Aadhaar record is available for this member.
                              Please request Aadhaar verification or upload the
                              Aadhaar document.
                            </div>
                          </div>
                        </v-card-text>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- MEMBER DETAILS PREVIEW -->
              <v-row>
                <v-col cols="12">
                  <v-card
                    v-if="member && Object.keys(member).length"
                    class="member-preview elevation-3 rounded-lg"
                  >
                    <v-row no-gutters>
                      <v-col
                        cols="12"
                        md="3"
                        class="d-flex align-center justify-center preview-photo"
                      >
                        <v-avatar size="110" class="elevation-6">
                          <img :src="member.Photo" alt="Profile" />
                        </v-avatar>
                      </v-col>

                      <v-col cols="12" md="9">
                        <v-card-text class="preview-details">
                          <div
                            class="d-flex justify-space-between align-center"
                          >
                            <div>
                              <div class="member-name">
                                {{ member.MemberName }}
                              </div>
                              <div class="member-sub">
                                {{ member.Designation }} •
                                {{ member.MembershipId }}
                              </div>
                            </div>
                          </div>

                          <v-divider class="my-3"></v-divider>

                          <v-row>
                            <v-col cols="12" md="6">
                              <div class="meta-label">WhatsApp</div>
                              <div class="meta-value">
                                {{ member.WhatsappNo || "—" }}
                              </div>
                            </v-col>

                            <v-col cols="12">
                              <div class="meta-label">Address</div>
                              <div class="meta-value">
                                {{ member.AddressTxt || "—" }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>

                  <div v-else class="empty-preview">
                    <v-row align="center" justify="center">
                      <v-col cols="12" md="8" class="text-center">
                        <v-icon color="grey" size="48"
                          >mdi-account-search</v-icon
                        >
                        <div class="mt-3 caption">
                          No member selected. Search by Membership ID to load
                          member details.
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <div class="action-wrapper">
            <!-- Disable Reason Alert -->
            <v-alert
              v-if="
                member &&
                Object.keys(member).length > 0 &&
                (!member.AadhaarVerifiedFlag || !member.ProfileStatusFlag)
              "
              type="warning"
              dense
              text
              class="disable-reason-alert mt-3"
            >
              <div class="disable-reason-title">
                <v-icon small class="mr-1">mdi-alert-circle-outline</v-icon>
                <strong>Save button is disabled because:</strong>
              </div>
              <ul class="disable-reason-list">
                <li
                  v-if="!member.AadhaarVerifiedFlag"
                  class="disable-reason-item"
                >
                  <v-icon x-small class="mr-1" color="error"
                    >mdi-close-circle</v-icon
                  >
                  <strong>Aadhaar Verification Required</strong> - Member's
                  Aadhaar details must be verified
                </li>
                <li
                  v-if="!member.ProfileStatusFlag"
                  class="disable-reason-item"
                >
                  <v-icon x-small class="mr-1" color="error"
                    >mdi-close-circle</v-icon
                  >
                  <strong>Profile Status Incomplete</strong> - Member must
                  complete their profile with all required documents
                </li>
              </ul>
            </v-alert>
          </div>
          <v-card-actions class="form-actions">
            <v-spacer />
            <v-btn text @click="closePrompt">Cancel</v-btn>
            <v-btn
              :disabled="
                !valid1 ||
                !member.AadhaarVerifiedFlag ||
                !member.ProfileStatusFlag
              "
              color="success"
              @click.prevent="confirmAlert"
              :loading="SubmitFlag"
            >
              <v-icon left>mdi-content-save</v-icon> Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import UploadSelectedMemberDocument from "@/view/pages/members/UploadSelectedMemberDocument.vue";
import UploadSelectedMemberPhoto from "@/view/pages/members/UploadSelectedMemberPhoto.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {
    UploadSelectedMemberDocument,
    UploadSelectedMemberPhoto,
  },
  props: {
    editRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      DialogFlag: true,
      refreshButtonFlag: false,
      menu1: false,

      memberDocumentPrompt: false,
      memberPhotoPrompt: false,
      MembershipId: "",
      member: {},

      rows: [],
      item: {},

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      LomCodeRules: [(v) => !!v || "Lom is required"],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Region is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      DesignationName: "",

      DesignationIdRules: [(v) => !!v || "Designation is required"],
      DesignationId: "",
      DesignationIdOptions: [],
      DesignationIdOptionsLoading: false,
      MemberFlag: false,
      AllMembers: [],

      CurrentYearId: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    MembershipId: function () {
      this.MembershipId = this.recordData.MembershipId;
    },
    LomCodeOptions: function () {
      this.LomCodeOptionsLoading = false;
      this.LomCode = this.recordData.LomId;
    },
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
      this.ZoneCode = this.recordData.ZoneId;
    },
    ZoneCode: function () {
      this.getLomCodeOptions();
    },
    LomCode: function () {
      this.getMemberIdOptions();
    },
    MemberId: function () {
      this.getMemberDetails();
    },
    DesignationIdOptions: function () {
      this.DesignationIdOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    hideMemberDocumentPrompt(flag) {
      console.log("hideMemberDocumentPrompt called");
      console.log({ flag });
      this.memberDocumentPrompt = false;
      if (flag) {
        this.member.document_flag = true;
      }
    },

    hideMemberPhotoPrompt(flag) {
      console.log("hideMemberPhotoPrompt called");
      console.log({ flag });
      this.memberPhotoPrompt = false;
      if (flag) {
        this.member.photo_flag = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "zgb_dis",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      var recordData = this.recordData;
      this.MembershipId = recordData.MembershipId;
      console.log("recordData=" + JSON.stringify(recordData));
      var YearwiseOfficesHeldId = recordData.YearwiseOfficesHeldId;
      if (YearwiseOfficesHeldId != "") {
        // this.getDesignationIdOptions();
        this.getLomCodeOptions();
        this.getMemberRecords();
        // this.MemberId = recordData.MemberId;
        this.DesignationId = recordData.DesignationId;
        this.DesignationName = recordData.DesignationName;
        // this.searchForm();
      } else {
        this.sweetAlert("error", "Designation details not fount", false);
        this.closePrompt();
      }
    },
    getMemberRecords() {
      console.log("getMemberRecords called");

      var MembershipId = this.MembershipId;
      console.log({ MembershipId });

      this.OverlayLoadingFlag = true;
      this.SearchFlag = true;
      this.MemberFlag = false;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nominate-member-subscription/info";
      var upload = {
        UserInterface: 2,
        Membership: MembershipId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );
      console.log("recordData:", this.recordData);

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;
      var data = {};

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.OverlayLoadingFlag = false;
          thisIns.SearchFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.member = records;
            thisIns.MemberFlag = true;

            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.OverlayLoadingFlag = false;
          thisIns.SearchFlag = false;
        });
    },
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },

    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditRecordPrompt");
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      this.AllMembers = [];
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        this.member = member;
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: member.value,
          MemberName: member.member_name,
          DesignationId: this.DesignationId,
          Designation: "",
        });
      }
    },
    getDesignationIdOptions() {
      console.log("getDesignationIdOptions called");
      this.DesignationIdOptionsLoading = true;
      var selectbox1_source = "DesignationId";
      var selectbox1_destination = "DesignationIdOptions";
      var selectbox1_url = "api/designation/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        OrganizationTypeId: 2,
        ExceptDesignationId: [1, 4, 5, 6, 7],
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      this.LomCodeOptionsLoading = true;
      this.MemberId = "";
      var selectbox1_source = "LomCode";
      var selectbox1_destination = "LomCodeOptions";
      var selectbox1_url = "api/year-wise-lom/lom-options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        YearCode: this.JciYearCode,
        ZoneCode: this.ZoneCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      this.MemberId = "";
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/zone/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      // this.MemberIdOptions = [];
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: this.LomCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      // add todo in store and clear all fields in dialog
      console.log("submitForm called");

      // this.resetMessageTxt();

      var result = this.$refs.form1.validate();

      var LomCode = this.member.LomId;
      var ZoneCode = this.member.ZoneId;
      var MemberId = this.member.MemberId;
      var DesignationId = this.DesignationId;
      var member = this.member;
      // var AllMembers = this.AllMembers;
      // var n1 = AllMembers.length;

      console.log(
        "LomCode=" +
          LomCode +
          ", MemberId=" +
          MemberId +
          ", DesignationId=" +
          DesignationId
      );

      if (result && LomCode != "" && MemberId != "" && DesignationId != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url +
          "api/year-wise-designation/new-governing-board-member-update";
        var upload = {
          UserInterface: 3,
          OrganizationTypeId: 2,
          YearCode: this.CurrentYearId,
          LomCode: LomCode,
          ZoneCode: ZoneCode,
          MemberId: MemberId,
          DesignationId: DesignationId,
          YearwiseOfficesHeldId: this.recordData.YearwiseOfficesHeldId,
          DateOfBirth: member.MemberDOB,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.LoadingFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.ProgessStart = 0;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              // thisIns.SuccessMessageTxtFlag = 1;
              // thisIns.SuccessMessageTxt = output;

              thisIns.closePrompt();
              // thisIns.AllMembers = [];
              // thisIns.ResultFlag = false;
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "";
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        if (n1 == "") {
          message += "Atleast one member is required. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    var ZoneCode = this.$session.get("ZoneId");
    ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
    console.log("ZoneCode=" + ZoneCode);
    this.ZoneCode = ZoneCode;

    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 12;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
    this.CurrentYearId = CurrentYearId;

    this.MembershipId = this.recordData.MembershipId;
    this.refreshPageData();
    this.getMemberRecords();
  },
};
</script>
<style lang="scss">
#new-zgb-team-members-edit,
#new-zgb-team-members-modifiy {
  font-family: "Inter", "Roboto", sans-serif;
  color: #1f2937;
}

/* Professional Header Styling */
.edit-header {
  background: linear-gradient(90deg, #1976d2 0%, #4e8ef7 100%);
  padding: 20px 24px;
  border-radius: 12px 12px 0 0;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.header-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.title-icon-wrapper {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.title-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.page-title {
  color: #ffffff;
  font-weight: 700;
  font-size: 22px;
  margin: 0;
  letter-spacing: -0.3px;
}

.page-desc {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.header-actions-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.year-badge {
  padding: 4px 12px !important;
  font-weight: 600;
  font-size: 12px;
}

.icon-action-btn {
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    transform: scale(1.1);
  }
}

/* Card and toolbar */
.form-card {
  border-radius: 12px;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff, #fbfdff);
}

/* Inputs and labels */
.field-label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}

.text-error {
  color: #e53935;
}

.member-details-card {
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.details-card-header {
  background: linear-gradient(90deg, #1976d2 0%, #4e8ef7 100%) !important;
  color: white !important;
  font-weight: 700 !important;
  padding: 16px 20px !important;
}

.details-subtitle {
  color: #6b7280 !important;
  font-size: 12px !important;
}

.portal-header {
  background: linear-gradient(90deg, #1976d2 0%, #4e8ef7 100%) !important;
  color: white !important;
  font-weight: 700 !important;
  padding: 16px 20px !important;
}

.aadhaar-header {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  font-weight: 700 !important;
  padding: 16px 20px !important;
}

.portal-details-card,
.aadhaar-card-container {
  border-radius: 12px;
  background: #fff;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08) !important;
  }
}
.control-input {
  background: #fff;
  border-radius: 8px;
}
.readonly-text {
  margin-top: 6px;
  font-weight: 600;
  color: #111827;
}

/* Member summary */
.member-summary {
  border-radius: 10px;
  background: #fff;
}
.member-summary-head {
  align-items: center;
}
.member-name {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}
.member-sub {
  color: #6b7280;
  margin-top: 4px;
}
.item-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  margin-right: 8px;
}

/* Portal & Aadhaar */
.portal-card,
.aadhaar-card {
  border-radius: 8px;
  background: #fff;
}
.card-title {
  font-weight: 700;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.portal-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px dashed rgba(15, 23, 42, 0.03);
}
.portal-row .label {
  color: #6b7280;
  font-weight: 600;
  font-size: 13px;
}
.portal-row .value {
  color: #111827;
  font-size: 14px;
}

.aadhaar-compact {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}
.aadhaar-name {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 6px;
}
.aadhaar-row {
  color: #4b5563;
  font-size: 13px;
  margin-bottom: 4px;
}

.aadhaar-empty {
  background: #fff7f7;
  border-radius: 8px;
}

/* Status chips */
.status-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Footer actions */
.form-actions {
  padding: 12px 18px;
  border-top: 1px solid rgba(15, 23, 42, 0.04);
}

.action-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
}

.disable-reason-alert {
  background-color: rgba(255, 152, 0, 0.08) !important;
  border: 1px solid rgba(255, 152, 0, 0.3) !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  margin-top: 12px !important;
}

.disable-reason-title {
  display: flex;
  align-items: center;
  color: #f57c00;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 8px;
}

.disable-reason-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.disable-reason-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #d32f2f;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 960px) {
  .edit-header {
    padding: 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .header-actions-top {
    width: 100%;
    justify-content: flex-end;
  }

  .member-summary {
    margin-bottom: 12px;
  }

  .page-title {
    font-size: 18px;
  }
}

@media (max-width: 600px) {
  .edit-header {
    padding: 12px 16px;
  }

  .header-title-section {
    gap: 12px;
  }

  .title-icon-wrapper {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 16px;
  }

  .page-desc {
    font-size: 12px;
  }

  .header-actions-top {
    gap: 8px;
  }

  .portal-value,
  .portal-label {
    font-size: 13px;
  }
}
</style>
